
<template>
  <div class="public-nav" style="position: relative;" :class="{'hide':isCollapse}">
    <div class='open_icon' @click="handleCollapse"  v-if="!isCollapse">
      <img :src="loadImage2('/menus/close.png')" alt="" >
    </div>
    <div class='open_icon' @click="handleCollapse" style="left: -8px" v-if="isCollapse">
      <img :src="loadImage2('/menus/open.png')" alt="">
    </div>
    <el-container style="height: auto">
      <!-- 侧边栏 -->
      <el-aside width="260px">
         <el-menu
          :default-active="$route.path"
          class="el-menu-vertical-nav"
          @select="handleselect"
          @open="handleOpen"
          @close="handleClose"
          ref="menus"
          :router="true"
          text-color="#fff"
        >

           <el-submenu  index="test" v-if="hasPermission(122)">
             <template slot="title">
               <div class="title">
                 <div class="icon-wrap">
                   <svg-icon icon-class="aside-shengchan" style="font-size:30px;"></svg-icon>
                 </div>
                 <span style="font-size: 16px;">{{$t("menuList.生产管理")}}</span>
               </div>
             </template>
             <!-- v-if="hasPermission(10)" -->
             <el-menu-item-group>
               <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(123)"  index="/productionManagement/personnelManagement">{{$t("menuList.生产人员管理")}}</el-menu-item>
               <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(124)"  index="/productionManagement/taskManagement/index">{{$t("menuList.生产任务管理")}}</el-menu-item>
               <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(125)"  index="/productionManagement/deviceCheck/index">{{$t("menuList.生产检测标准")}}</el-menu-item>
               <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(213)"  index="/productionManagement/report/index">{{$t("menuList.生产系统接入")}}</el-menu-item>
             </el-menu-item-group>
           </el-submenu>

        <el-submenu  index="1" v-if="hasPermission(1)">
            <template slot="title">
              <div class="title">
                <div class="icon-wrap">
                   <svg-icon icon-class="sim" style="font-size:30px;"></svg-icon>
                </div>
                <span style="font-size: 16px;">{{$t("menuList.资产管理")}}</span>
              </div>
            </template>
            <!-- v-if="hasPermission(10)" -->
             <el-menu-item-group>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(6)"  index="/assets/battery">{{$t("menuList.电池列表")}}</el-menu-item>
               <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(158)"  index="/assets/battery/param">{{$t("menuList.电池状态总览")}}</el-menu-item>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(69)"  index="/assets/centerControl">{{$t("menuList.中控列表")}}</el-menu-item>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(7)"  index="/assets/equipmentList">{{$t("menuList.电池出库")}}</el-menu-item>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(70)"  index="/assets/centralControlOutStorage">{{$t("menuList.中控出库")}}</el-menu-item>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(108)"  index="/assets/assetInventory">{{$t("menuList.资产出入库")}}</el-menu-item>
               <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(218)"  index="/assets/batteryModel">{{$t("menuList.品牌型号")}}</el-menu-item>
             </el-menu-item-group>
        </el-submenu>


         <el-menu-item index="/assets/customerList" class="firstmenus" v-if="hasPermission(2)">
               <div class="title">
                  <div class="icon-wrap">
                    <svg-icon icon-class="kehu" style="font-size: 30px" ></svg-icon>
                  </div>
                  <span style="font-size: 16px;">{{ $t("menuList.客户管理") }}</span>
              </div>
        </el-menu-item>



           <el-submenu  index="appUser" v-if="hasPermission(146)">
             <template slot="title">
               <div class="title">
                 <div class="icon-wrap">
                   <svg-icon icon-class="producte" style="font-size: 30px" ></svg-icon>
                 </div>
                 <span style="font-size: 16px;">{{ $t("menuList.用户管理") }}</span>
               </div>
             </template>
             <!-- v-if="hasPermission(10)" -->
             <el-menu-item-group>

               <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(84)"  index="/appUser/center">{{$t("menuList.中控用户")}}</el-menu-item>
               <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(147)"  index="/appUser/bms">{{$t("menuList.BMS用户")}}</el-menu-item>
               <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(236)"  index="/appUser/bms/mobile">{{$t("menuList.注册手机号")}}</el-menu-item>
               <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(252)"  index="/appUser/feedback">{{$t("menuList.问题反馈")}}</el-menu-item>
             </el-menu-item-group>
           </el-submenu>




        <el-menu-item index="/assets/manufacturersList" class="firstmenus" v-if="hasPermission(3)">
               <div class="title">
                  <div class="icon-wrap">
                    <svg-icon icon-class="chukuguangli" style="font-size: 30px" ></svg-icon>
                  </div>
                  <span style="font-size: 16px;">{{ $t("menuList.厂家管理") }}</span>
              </div>
        </el-menu-item>

           <el-menu-item index="/brand" class="firstmenus" v-if="hasPermission(230)">
             <div class="title">
               <div class="icon-wrap">
                 <svg-icon icon-class="brand" style="font-size: 30px" ></svg-icon>
               </div>
               <span style="font-size: 16px;">{{ $t("menuList.品牌方") }}</span>
             </div>
           </el-menu-item>


           <el-menu-item index="/assets/bmsRemoteCommand/params" class="firstmenus" v-if="hasPermission(93)">
             <div class="title">
               <div class="icon-wrap">
                 <svg-icon icon-class="order" style="font-size: 30px" ></svg-icon>
               </div>
               <span style="font-size: 16px;">{{ $t("menuList.BMS参数管理") }}</span>
             </div>
           </el-menu-item>
           <el-menu-item index="/assets/bmsRemoteCommand/batchIssuanceParameters" class="firstmenus" v-if="hasPermission(98)">
             <div class="title">
               <div class="icon-wrap">
                 <svg-icon icon-class="yuancheng" style="font-size: 30px" ></svg-icon>
               </div>
               <span style="font-size: 16px;">{{ $t("menuList.BMS远程指令") }}</span>
             </div>
           </el-menu-item>

           <el-menu-item index="/assets/operationLog/index" class="firstmenus" v-if="hasPermission(119)">
             <div class="title">
               <div class="icon-wrap">
                 <svg-icon icon-class="logs" style="font-size: 30px" ></svg-icon>
               </div>
               <span style="font-size: 16px;">{{ $t("menuList.操作日志") }}</span>
             </div>
           </el-menu-item>

           <el-menu-item index="/assets/bmsRemoteCommand/threeSystemManagement" class="firstmenus" v-if="hasPermission(103)">
             <div class="title">
               <div class="icon-wrap">
                 <svg-icon icon-class="three" style="font-size: 30px" ></svg-icon>
               </div>
               <span style="font-size: 16px;">{{ $t("menuList.第三方运营系统接入管理") }}</span>
             </div>
           </el-menu-item>





           <el-submenu  index="bmsRenew" v-if="canManageBmsRenew()">
             <template slot="title">
               <div class="title">
                 <div class="icon-wrap">
                   <svg-icon icon-class="order" style="font-size: 30px" ></svg-icon>
                 </div>
                 <span style="font-size: 16px;">{{ $t("menuList.服务费管理") }}</span>
               </div>
            </template>
            <el-menu-item-group>
              <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(278)" index="/assets/bmsRenew/overview">{{ $t("menuList.服务费总览") }}</el-menu-item>

              <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(280)" index="/assets/bmsRenew/clientFee">{{ $t("menuList.客户服务费设置") }}</el-menu-item>
              <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(254)" index="/assets/bmsRenew/right">{{ $t("menuList.设备服务费明细") }}</el-menu-item>
              <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(262)" index="/assets/bmsRenew/bill">{{ $t("menuList.服务费账单") }}</el-menu-item>
<!--              <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(273)" index="/assets/bmsRenew/capitalFlow">{{ $t("menuList.资金流水") }}</el-menu-item>-->
            </el-menu-item-group>
          </el-submenu>


         <el-submenu  index="2" v-if="hasPermission(4)">
            <template slot="title">
              <div class="title">
                <div class="icon-wrap">
                   <svg-icon icon-class="baofei" style="font-size:30px;"></svg-icon>
                </div>
                <span style="font-size: 16px;">{{ $t("menuList.告警管理") }}</span>
              </div>
            </template>
            <!-- v-if="hasPermission(10)" -->
             <el-menu-item-group>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(87)"  index="/assets/equipmentAlarmList">{{ $t("menuList.电池告警列表") }}</el-menu-item>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(88)"  index="/assets/centralControlAlarm">{{ $t("menuList.中控告警列表") }}</el-menu-item>
               <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(197)"  index="/alarm/state/index">{{ $t("menuList.电池告警台账") }}</el-menu-item>
             </el-menu-item-group>

           <el-submenu  index="165"  v-if="hasPermission(165)">
             <template slot="title">
               <div class="title">
                 <!-- <div class="icon-wrap">
                   <svg-icon icon-class="order" style="font-size: 32px" ></svg-icon>
                 </div> -->
                 <span style="margin-left:12px">{{$t("menuList.告警推送")}}</span>
               </div>
             </template>
             <el-menu-item-group  v-if="hasPermission(166)">
               <el-menu-item  class="firstmenus" style="padding-left:85px;" index="/alarm/push-config/mp">{{$t("menuList.公众号")}}</el-menu-item>
             </el-menu-item-group>

             <el-menu-item-group  v-if="hasPermission(167)">
               <el-menu-item class="firstmenus" style="padding-left:85px;"  index="/alarm/push-config/sms">{{$t("menuList.短信")}}</el-menu-item>
             </el-menu-item-group>

             <el-menu-item-group  v-if="hasPermission(168)">
               <el-menu-item class="firstmenus" style="padding-left:85px;"  index="/alarm/push-config/voice">{{$t("menuList.电话")}}</el-menu-item>
             </el-menu-item-group>
           </el-submenu>
        </el-submenu>

        <!-- <el-menu-item index="/assets/upperComputer" class="firstmenus" v-if="hasPermission(39)">
               <div class="title">
                  <div class="icon-wrap">
                    <svg-icon icon-class="xianshang" style="font-size: 30px" ></svg-icon>
                  </div>
                  <span style="font-size: 16px;">{{$t('上位机')}}</span>
              </div>
        </el-menu-item> -->
        <el-submenu  index="10" v-if="hasPermission(39)">
            <template slot="title">
              <div class="title">
                <div class="icon-wrap">
                   <svg-icon icon-class="shengc" style="font-size:30px;"></svg-icon>
                </div>
                <span style="font-size: 16px;">{{ $t("menuList.上位机") }}</span>
              </div>
            </template>

             <el-menu-item-group>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(60)"  index="/assets/upperComputer">{{ $t("menuList.上位机下载") }}</el-menu-item>
             </el-menu-item-group>
<!--             <el-menu-item-group>-->
<!--             <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(54)" index="/assets/ProductManagement/params">{{ $t("menuList.上位机参数") }}</el-menu-item>-->
<!--           </el-menu-item-group>-->
        </el-submenu>
        <el-submenu  index="9" v-if="hasPermission(47)">
            <template slot="title">
              <div class="title">
                <div class="icon-wrap">
                   <svg-icon icon-class="guanliyuan" style="font-size:30px;"></svg-icon>
                </div>
                <span style="font-size: 16px;">{{ $t("menuList.售后管理") }}</span>
              </div>
            </template>
             <el-menu-item-group>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(48)"
                 index="/assets/afterSales">{{ $t("menuList.售后工单") }}</el-menu-item>
             </el-menu-item-group>
        </el-submenu>


         <el-submenu index="8"  v-if="hasPermission(5)">
            <template slot="title">
              <div class="title">
                <div class="icon-wrap">
                   <svg-icon icon-class="xitong" style="font-size:30px;"></svg-icon>
                </div>
                <span style="font-size: 16px;">{{ $t("menuList.系统管理") }}</span>
              </div>
            </template>
             <el-menu-item-group>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(26)"  index="/assets/systemSet/accountAdmin/index">{{ $t("menuList.账号管理") }}</el-menu-item>
             </el-menu-item-group>
              <el-menu-item-group>
                <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(27)"  index="/assets/systemSet/roleAdmin/index">{{ $t("menuList.角色管理") }}</el-menu-item>
             </el-menu-item-group>

             <el-menu-item-group>
               <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(91)"  index="/assets/systemSet/loginLog/index">{{ $t("menuList.登录日志") }}</el-menu-item>
             </el-menu-item-group>

           <el-menu-item-group>
             <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(242)"  index="/upgrade/verUp/index">{{ $t("menuList.版本更新日志") }}</el-menu-item>
           </el-menu-item-group>
           <el-menu-item-group>
             <el-menu-item class="firstmenus" style="padding-left:70px;" v-if="hasPermission(243)"  index="/upgrade/verUpSet/index">{{ $t("menuList.版本升级(内部)") }}</el-menu-item>
           </el-menu-item-group>
        </el-submenu>


        </el-menu>
      </el-aside>


    </el-container>
  </div>
</template>

<style lang="scss" scoped>
.hide{
  //display: none;
  width: 0px;
}
.open_icon {
  // width: 25px;
  width: 45px;
  height: 95px;
  // background: #001F38;
  cursor: pointer;
  z-index: 10;
  position: fixed;
  left: 249px;
  top: 50%;
  margin-top: calc(95px / 2 * -1);
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
  }

}
.title {
  display: flex;
  align-items: center;
  .icon-wrap {
    display: flex;
    align-items: center;
    width: 30px;
    height: 30px;
    line-height: 30px;
    padding-right: 10px;
    [data-theme="theme1"] & {
      color: #00f7ef;
    }
    [data-theme="theme2"] & {
      color: #fff;
    }
    [data-theme="theme2_skyblue"] & {
      color: #0060aa;
    }
  }
}
</style>

<script>
import { mapGetters } from "vuex";
import {EventBus} from "@/utils/event-bus";
import UpgradeUtil from "@/pages/upgrade/UpgradeUtil";
export default {
  inject: ["reload"], // 注入重载的功能（注入依赖）
  computed: {
    ...mapGetters(["theme"]),
  },

  data() {
    return {
      isCollapse: false,
      editableTabs2: [
        {
          title: "电池管理",
          name: "1",
          closable: false,
        },
      ],
    };
  },
 mounted() {
  // UpgradeUtil.open()
 },
  methods: {
    // 侧边栏展开收起
    handleCollapse() {
      this.isCollapse = !this.isCollapse;
      EventBus.$emit("collapse", this.isCollapse);
      $(".show-aside").css({
        "width": "64px",
      });
    },
    //权限控制
    hasPermission(id) {
      // console.log(id,"id")
      return this.$store.getters.hasPermission(id);
    },
    canManageBmsRenew() {
      // 父菜单只负责承载入口；只要角色拥有任一续费子功能，就允许展开，避免漏勾父权限导致页面完全不可见。
      return this.hasPermission(278) || this.hasPermission(254) || this.hasPermission(280) || this.hasPermission(262) || this.hasPermission(273);
    },
    // showBG(){
    //     return this.theme=="" || this.theme=="theme1"
    // },

    refs(name) {
      var that = this;
      that.$emit("listnone", name);
    },
    handleselect: function (a, b, index) {
      this.reload(); // 点击侧边栏重新载入页面
      // console.log(a)
      // console.log(index.itemStyle)
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClick() {},
  },
  //重写点击菜单的跳转方法
  // async mounted() {
  //     this.$refs.menus.routeToItem=(item)=>{
  //         let route = item.route || item.index;
  //         try {
  //             this.toCachePage({path:route});
  //         } catch (e) {
  //             console.error(e);
  //         }
  //      //   this.toCachePage({path:item})
  //     }
  // },
  created() {},
};
</script>



// WEBPACK FOOTER //
// src/components/Home.vue